/**
 * 根据用户 ID 从封面数组中确定性地选择一张封面。
 * 使用 DJB2 哈希算法保证同一用户始终得到同一张图，不同用户分布均匀。
 *
 * @param userId 用户唯一标识
 * @param loadingCoverUrls 封面 URL 数组
 * @returns 选中的封面 URL，数组为空时返回 null
 */
export function selectCoverUrl(
  userId: string,
  loadingCoverUrls: string[],
): string | null {
  if (!loadingCoverUrls || loadingCoverUrls.length === 0)
    return null

  let hash = 5381
  for (let i = 0; i < userId.length; i++)
    hash = ((hash << 5) + hash + userId.charCodeAt(i)) | 0

  const index = Math.abs(hash) % loadingCoverUrls.length
  return loadingCoverUrls[index]
}
